import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';

import { AuthGuardService } from '@app/core/_guards/auth/auth.guard';

import { CallbackComponent } from '@app/callback/callback.component';
import { ContentLayoutComponent } from './layout/content-layout/content-layout.component';

import * as fromGuards from '@app/modules/admission/_guards';

const defaultGuards = [fromGuards.OrganizationGuard, fromGuards.PermissionAccountsGuard, fromGuards.ModulesGuard];

const appRoutes: Routes = [
  { path: 'callback', component: CallbackComponent },
  { path: 'preauthorize', component: CallbackComponent },
  {
    path: '',
    component: ContentLayoutComponent,
    canActivate: [AuthGuardService],
    children: [
      {
        path: '',
        canActivate: [...defaultGuards],
        loadChildren: () => import('@app/modules/admission/admission.module').then(m => m.AdmissionModule)
      },
      {
        path: 'company',
        canActivate: [...defaultGuards],
        loadChildren: () => import('@app/modules/settings/settings.module').then(m => m.DashboardCompanyModule)
      },
      {
        path: 'company/benefits',
        canActivate: [...defaultGuards],
        loadChildren: () => import('@app/modules/benefits/dashboard-benefits.module').then(m => m.DashboardBenefitsModule)
      },
      {
        path: 'preferences',
        canActivate: [...defaultGuards],
        loadChildren: () => import('@app/modules/preferences/preferences.module').then(m => m.DashboardPreferencesModule)
      },
      {
        path: 'search',
        canActivate: [...defaultGuards],
        loadChildren: () => import('@app/modules/search/search.module').then(m => m.DashboardSearchModule)
      },
      {
        path: 'models',
        canActivate: [...defaultGuards],
        loadChildren: () => import('@app/modules/models/dashboard-models.module').then(m => m.DashboardModelsModule)
      },
      {
        path: 'layouts',
        canActivate: [...defaultGuards],
        loadChildren: () => import('@app/modules/layouts/layouts.module').then(m => m.LayoutsModule)
      },
      {
        path: 'export/report',
        canActivate: [...defaultGuards],
        loadChildren: () => import('@app/modules/admission/admission.module').then(m => m.AdmissionModule)
      },
      {
        path: 'signatures',
        canActivate: [...defaultGuards],
        loadChildren: () => import('@app/modules/signatures/signatures.module').then(m => m.SignaturesModule)
      },
      {
        path: 'analytics',
        canActivate: [...defaultGuards],
        loadChildren: () => import('@app/modules/analytics/analytics.module').then(m => m.AnalyticsModule)
      },
      {
        path: 'dynamic-documents-builder',
        canActivate: [...defaultGuards],
        loadChildren: () =>
          import('@app/modules/dynamic-documents-builder/dynamic-documents-builder.module').then(m => m.DynamicDocumentsBuilderModule)
      },
      {
        path: 'storybook-design-system',
        canActivate: [...defaultGuards],
        loadChildren: () => import('@app/modules/design-system/design-system.module').then(m => m.DesignSystemModule)
      }
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, {
    preloadingStrategy: PreloadAllModules
})
  ],
  exports: [RouterModule],
  providers: [...fromGuards.guards]
})
export class AppRoutingModule {}
